import { ProgramTypes } from 'legacy/lut/classes/models/ProgramTypes'
import { useCallback, useEffect, useState } from 'react'

import { getCrudRoles } from '../helpers/getCrudRoles'

interface IUseCrudRolesParameters {
  measure: {
    startLoadData: () => void
    stopLoadData: () => void
  }
  programType: ProgramTypes
}

export const useCrudRoles = ({
  programType,
  measure: { startLoadData, stopLoadData },
}: IUseCrudRolesParameters) => {
  /** -------------------- Variables ----------------------- */
  const [isLoading, setIsLoading] = useState(false)

  const crudRoles = getCrudRoles()

  /** -------------------- Methods ----------------------- */
  const fetchData = useCallback(async () => {
    setIsLoading(true)
    startLoadData()
    await crudRoles.fetch()
    stopLoadData()
    setIsLoading(false)
  }, [startLoadData, stopLoadData, crudRoles])

  /** -------------------- Effects ----------------------- */
  useEffect(() => {
    crudRoles.setRoot(`JBPContactType${programType.replace(/\s+/, '')}`)
    crudRoles.setSort({ field: 'value', dir: 'asc' })
    fetchData()
  }, [crudRoles, programType, fetchData])

  return {
    isLoading,
    crudRoles,
  }
}
